import * as Parse from 'parse'
import { SharedFuture } from '../shared-future'
import { Objects } from '../../../../../server/src/shared-with-client/object-definitions'
import { Establishment } from './establishment'

interface FindParams {
    establishment?: Establishment
}

export class CustomerService {
    readonly load = new SharedFuture<{ establishment: Establishment; customers: Objects.User._Parse.ForEstablishmentQuery[] } | undefined, FindParams>(
        (args) => this.loadHandler(args),
        (args) => {
            const { establishment } = args
            return establishment ? establishment.id : ''
        },
        { time: { ttl: 60000 } }
    )

    constructor() {}

    private async loadHandler({
        establishment,
    }: FindParams): Promise<{ establishment: Establishment; customers: Objects.User._Parse.ForEstablishmentQuery[] } | undefined> {
        if (!establishment) {
            return undefined
        }

        const ESTABLISHMENT_COLLECTION: Objects.Establishment.Collection = 'Establishment'
        const establishmentFilter = new Parse.Object(ESTABLISHMENT_COLLECTION)
        establishmentFilter.id = establishment.id

        const query = new Parse.Query<Objects.User._Parse.ForEstablishmentQuery>(Parse.User)
            .equalTo('establishment', establishmentFilter)
            .notEqualTo('isDeleted', true)
            .ascending(['firstName', 'lastName'])
            .select('firstName', 'lastName', 'username')
            .limit(10000000000)

        const customers = await query.find()
        customers.sort((userA, userB) => {
            const sortValueA = `${userA.get('firstName')}${userA.get('lastName')}`.toLowerCase()
            const sortValueB = `${userB.get('firstName')}${userB.get('lastName')}`.toLowerCase()

            if (sortValueA > sortValueB) {
                return 1
            }

            if (sortValueA < sortValueB) {
                return -1
            }

            return 0
        })

        return { customers, establishment }
    }
}
